<template>
  <div class="showPaper edit-style detail">
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p class="title">试卷详情</p>
      <div class="hidden-box"></div>
      <!-- <img src="@/assets/learning/setting.png" alt="" @click="toSetting" /> -->
    </div>

    <div v-if="examPaper.updateTime" class="paper-box">
      <p>{{ examPaper.name }}</p>
      <div class="paper-msg">
        <span v-if="examPaper.city">{{ examPaper.city.split("-")[0] }}</span>
        <span> | </span>
        <span>{{ examPaper.updateTime.split(" ")[0] }}</span>
        <span> | </span>
        <span>总分：{{ examPaper.score }}</span>
        <span> | </span>
        <span>浏览：{{ examPaper.countView }}</span>
      </div>
    </div>
    <!-- {{ examPaper.filePath }} -->
    <!-- <div
      v-if="examPaper.filePath && examPaper.filePath.length > 0"
      class="down-box"
      @click="down"
    >
      下载试卷
    </div> -->
    <div class="html-box">
      <!-- 已转换好 并且没有试题 -->
      <template
        v-if="examPaper.statusConvert == 1 && examPaperQuestions.length == 0"
      >
        <!-- {{
          examPaper.filePath && examPaper.filePath[0].split(".")[1] != "docx"
        }} -->
        <template
          v-if="
            examPaper.filePath && examPaper.filePath[0].split('.')[1] == 'docx'
          "
        >
          <div v-html="examPaper.resultPath"></div>
        </template>
        <!-- {{ examPaper.resultPath }} -->
        <template
          v-if="
            examPaper.filePath && examPaper.filePath[0].split('.')[1] != 'docx'
          "
        >
          <img
            v-for="(v, i) in examPaper.resultPath"
            :key="i"
            :src="cdn + v"
            alt=""
          />
        </template>
      </template>
      <!-- 未转换好 -->
      <template v-if="examPaper.statusConvert == 0">
        <!-- word -->
        <template
          v-if="
            examPaper.filePath && examPaper.filePath[0].split('.')[1] == 'docx'
          "
        >
          <a :href="word + examPaper.filePath[0]">查看word</a>
        </template>
        <!-- pdf或者img -->
        <template
          v-if="
            examPaper.filePath && examPaper.filePath[0].split('.')[1] != 'docx'
          "
        >
          <img v-for="(v, i) in examPaper.filePath" :key="i" :src="v" alt="" />
        </template>
      </template>
    </div>
    <div class="question-list-box">
      <div
        v-for="(v, i) in examQuestions"
        :key="i"
        class="question-list"
        @click="linkTo(v)"
      >
        <div class="question-list-top">
          <span class="number">{{ 10 > i + 1 ? "0" + (i + 1) : i + 1 }}</span>
          <span class="name">{{ v.typeName }}</span>
          <span>{{ v.difficulty | setName(difficultyList) }}</span>
        </div>
        <div class="qusetion-box" v-html="v.question"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { difficultyList } from "@/util/constdata";
import {
  getexampaperinfo,
  updateexampapercountview,
  getexampaperimgzip,
} from "@/api/interface";
export default {
  name: "ShowPaper",
  data() {
    return {
      word: "https://view.officeapps.live.com/op/view.aspx?src=https://static.wtjy.com/",
      cdn: "https://static.wtjy.com/",
      difficultyList: difficultyList,
      examPaper: {},
      examPaperQuestions: [],
      examQuestions: [],
    };
  },
  created() {
    this.showDetail();
    // this.showDetail();
  },
  methods: {
    linkTo(val) {
      this.$store.commit("setWorngData", val);
      this.$router.push({
        name: "PaperQuestion",
      });
    },
    downFile(url) {
      var evt;
      const link = document.createElement("a");
      if (document.fireEvent) {
        link.setAttribute("href", url);
        window.open(url);
      } else {
        let newUrl = url;
        if (url.split(".")[url.split(".").length - 1] == "pdf") {
          newUrl = newUrl + "?response-content-type=application/octet-stream";
        }
        link.setAttribute("href", newUrl);
        evt = document.createEvent("MouseEvents");
        evt.initEvent("click", true, true);
        link.dispatchEvent(evt);
      }
      link.click();
    },
    down() {
      let str = this.examPaper.filePath[0].split(".");
      if (str[1] == "docx" || str[1] == "pdf") {
        let url = this.cdn + this.examPaper.filePath[0];
        this.downFile(url);
      } else {
        let data = {
          id: this.$route.query.id,
        };
        Toast("请求中，请稍后！");
        getexampaperimgzip(data).then((res) => {
          // console.log(res);
          let url = this.cdn + res.data.url;
          this.downFile(url);
        });
      }
    },
    showDetail() {
      let data = {
        id: this.$route.query.id,
      };
      getexampaperinfo(data).then((res) => {
        this.examPaper = res.data.examPaper;
        this.examPaperQuestions = res.data.examPaperQuestions;
        let questionItem = [];
        this.examPaperQuestions.forEach((index) => {
          let typeName = index.examQuestionMaterialOrder
            ? index.examQuestionMaterialOrder
            : index.examQuestionOrder;
          if (questionItem.indexOf(typeName) == -1) {
            questionItem.push(typeName);
            res.data.examQuestions.forEach((item) => {
              if (index.examQuestionId == item.id) {
                item.typeName = typeName;
                this.examQuestions.push(item);
              }
            });
          }

          //
        });
        // this.examQuestions = res.data.examQuestions;
        if (this.examPaper.filePath.split(",")[1] != "docx") {
          this.examPaper.resultPath = this.examPaper.resultPath.split(",");
          // cdn
        }
      });
      let data1 = {
        id: this.$route.query.id,
      };
      updateexampapercountview(data1).then(() => {});
    },
    downView() {
      // console.log("222222222");
      this.$router.push({
        name: "TestPaper",
      });
      // if (this.isiOS) {
      //   window.webkit.messageHandlers.commonCall.postMessage({
      //     type: 1
      //   });
      // } else {
      //   window.mobile.closeMobileUI();
      // }
    },
  },
};
</script>
<style lang="scss">
.showPaper {
  img {
    max-width: 100%;
    height: auto !important;
  }
}
</style>
<style scoped lang="scss">
.showPaper {
  background-color: rgba(0, 0, 0, 0.04);
  .down-box {
    color: #7b9cc7;
    background-color: white;
    padding: 0 12px;
  }
  .html-box {
    background-color: white;
    padding: 12px;
    img {
      width: 100%;
      margin-bottom: 12px;
    }
    a {
      color: #7b9cc7;
    }
  }
  .question-list-box {
    padding: 12px;
    .question-list-top {
      margin-bottom: 6px;
      span {
        margin-right: 6px;
        vertical-align: middle;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
      }
      .number {
        padding: 2px 3px;
        background-color: #7b9cc7;
        border-radius: 50%;
        color: #ffffff;
      }
      .name {
        color: #7b9cc7;
      }
    }
    .question-list {
      padding: 12px;
      background-color: #ffffff;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 12px;
    }
    .qusetion-box {
      overflow: hidden;
    }
  }
  .paper-box {
    padding: 12px;
    background-color: #ffffff;
    .paper-msg {
      span {
        color: rgba(0, 0, 0, 0.5);
        margin-right: 5px;
        font-size: 12px;
      }
    }
    p {
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 19px;
    }
  }
}
</style>
